/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLTIProvider } from './BaseLTIProvider';
import { LMSCapabilities } from './LMSCapabilities';
import { LTI1p3ProviderPresentationAsJSON } from './LTI1p3ProviderPresentationAsJSON';
const BaseLTI1p3ProviderParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'lms',
        /* #__PURE__ */ parsers.exactly('Blackboard', 'Brightspace', 'Bronte', 'Canvas', 'Moodle', 'Revel', 'XL'),
    ],
    ['capabilities', LMSCapabilities],
    ['version', /* #__PURE__ */ parsers.exactly('lti1.3')],
    ['iss', codecString],
    ['presentation', LTI1p3ProviderPresentationAsJSON],
]), BaseLTIProvider);
export class BaseLTI1p3Provider extends BaseLTIProvider {
    static decode(input) {
        return BaseLTI1p3ProviderParser.decode(input).map(res => new BaseLTI1p3Provider(res));
    }
    static unsafeDecode(input) {
        return BaseLTI1p3Provider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseLTI1p3ProviderParser.encode(data);
    }
    static schema() {
        return BaseLTI1p3ProviderParser.schema();
    }
}
